import React, { useEffect, useState } from 'react';

const reviews = [
    {
        id: 1,
        name: 'Shruthi Gladys',
        review: `I've been choosing Prapancha pravasa for all my trips, and they never disappoint! From planning the itinerary to booking the best stays and organizing local experiences, they take care of everything with such professionalism and warmth. Every trip becomes hassle-free and memorable, thanks to their attention to detail and personalized service.
Their team is always available to assist, and they truly understand what a traveler wants.
Whether it's a relaxing getaway or an adventure-packed vacation, I know I can count on them every single time. Highly recommend prapancha pravasa if you're looking for a reliable and friendly travel partner!`,
        rating: 5,
        image: '/review6.jpg',
        date: '2025-05-01',
    },
    {
        id: 2,
        name: 'Anusha Govind',
        review: `Where to start from….😍Beautiful experience with “Prapancha Pravasa Tours Pvt Ltd” for the trip thailand, very comfortable team with the good package price, had the different experience for all the 3 days which was unforgettable. They guarantee that
the assurance of covering all the places with wonderful guidance, and take cares everything in neat. The places are mesmerising like tiger park paragliding scuba diving..must visit place. Please go ahead and book now with PRAVASA PRAPANCHA! Best wishes for the entire team. `,
        rating: 4,
        image: '/review5.jpg',
        date: '2025-04-15',
    },
    {
        id: 3,
        name: 'Mani Govind',
        review: `A team to be cherished as always is PRAPANCHA PRAVASA TOURS PVT LTD, we had been to Dubai, and had a mesmerizing experience with all the places this team has shown for us.. all were wow places😍 like bhurj khalifa, cruise dinner, desert safari, dubai frame etc. Also they make sure to provide us the best comfort rooms, hotels for lunch, dinner. And,they neatly guide through all the ways we are in need for. Finally we enjoyeddd a lot thankyou team:) I recommend all to take a step and now book with prapancha pravasa tour pvt Ltd.`,
        rating: 4,
        image: '/review2.jpg',
        date: '2025-03-22',
    },
    {
        id: 4,
        name: 'Omkar murthy',
        review: 'It was memorable trip to every one in our group we enjoyed a lot and it was devotional trip had blessing of all the Devis which we never visited thanks for the organiser of Prapancha Pravasa team even our sarathi was also very humble person thanks for the team .',
        rating: 5,
        image: '/review4.jpg',
        date: '2025-02-10',
    },
    {
        id: 5,
        name: 'Shailaja',
        review: `Excellent organization, knowledgeable guides, comfortable accommodations, and memorable experiences. I would like to give 98/100.. Very friendly owner and the Managar, the hospitality was great. As per itinerary they have covered all places in Thailand, we had a good Indian food. From the day arrival to last day departure, team was there with us to take care.. Overall me and my friend had good and beautiful experience`,
        rating: 4,
        image: '/review3.jpg',
        date: '2025-01-05',
    },
    {
        id: 6,
        name: 'Nitin Gowda',
        review: `Very good experience with Prapancha PraVasa Private Limited team
We visited last week. I have private peak And private stay is too good food and that person we will give five star for Pramod that guys guide hundred percent worth full
And we satisfied, Kudure, Mukka, Kunjal peak and homestay private peak and waterfalls is very beautiful. Private no one is there is also feeling will alone peaceful place.
Thank you, Prapancha PraVasa Private Limited`,
        rating: 4,
        image: '/review1.jpg',
        date: '2025-01-05',
    },
];

const ReviewSlides = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % reviews.length);
        }, 4000); // Change slide every 4 seconds

        return () => clearInterval(interval); // Cleanup on unmount
    }, []);

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % reviews.length);
    };

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + reviews.length) % reviews.length);
    };

    const ReviewCard = ({ review, position }) => {
        let className = 'bg-white shadow-lg rounded-xl p-4 sm:p-6 text-center flex-shrink-0 transition-all duration-500 ease-in-out w-full sm:max-w-64';
        let isVisible = true;

        if (position === 'center') {
            className += ' scale-100 sm:scale-110 z-10 -translate-y-0 sm:-translate-y-8 border-2 border-custom-yellow sm:max-w-80';
        } else if (position === 'left-1' || position === 'right-1') {
            className += ' scale-90 opacity-75 hidden sm:block';
        } else if (position === 'left-2' || position === 'right-2') {
            className += ' scale-85 opacity-50 hidden sm:block';
        } else {
            isVisible = false; // Hide reviews beyond left-2 or right-2
        }

        if (!isVisible) return null;

        return (
            <div className={className}>
                <img
                    src={review.image}
                    alt={`${review.name} avatar`}
                    className="w-12 h-12 sm:w-16 sm:h-16 rounded-full mx-auto mb-4 object-cover"
                />
                <h3 className="text-base sm:text-lg font-semibold text-custom-blue">
                    {review.name}
                </h3>
                <p className="text-gray-600 text-xs sm:text-sm mt-2 line-clamp-4">
                    {review.review}
                </p>
                <div className="flex justify-center mt-3">
                    {[...Array(review.rating)].map((_, i) => (
                        <svg
                            key={i}
                            className="w-4 h-4 sm:w-5 sm:h-5 text-custom-yellow fill-current"
                            viewBox="0 0 20 20"
                        >
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.97a1 1 0 00.95.69h4.178c.969 0 1.371 1.24.588 1.81l-3.39 2.465a1 1 0 00-.364 1.118l1.286 3.97c.3.921-.755 1.688-1.54 1.118l-3.39-2.465a1 1 0 00-1.175 0l-3.39 2.465c-.784.57-1.838-.197-1.54-1.118l1.286-3.97a1 1 0 00-.364-1.118L2.57 9.397c-.783-.57-.38-1.81.588-1.81h4.178a1 1 0 00.95-.69l1.286-3.97z" />
                        </svg>
                    ))}
                </div>
                <p className="text-gray-400 text-xs mt-3">{review.date}</p>
            </div>
        );
    };

    // Calculate indices for left-2, left-1, center, right-1, right-2
    const getReviewPositions = () => {
        const totalReviews = reviews.length;
        return {
            'left-2': (currentSlide - 2 + totalReviews) % totalReviews,
            'left-1': (currentSlide - 1 + totalReviews) % totalReviews,
            center: currentSlide,
            'right-1': (currentSlide + 1) % totalReviews,
            'right-2': (currentSlide + 2) % totalReviews,
        };
    };

    const positions = getReviewPositions();

    return (
        <div className="max-w-full sm:max-w-7xl mx-auto py-8 sm:py-12 px-4 sm:px-0">
            <h2 className="text-2xl sm:text-3xl font-bold text-custom-blue text-center mb-6 sm:mb-6">
                Customer Reviews
            </h2>
            <div className="relative flex justify-center items-center gap-2 sm:gap-4 p-16 overflow-hidden">
                <ReviewCard review={reviews[positions['left-2']]} position="left-2" />
                <ReviewCard review={reviews[positions['left-1']]} position="left-1" />
                <ReviewCard review={reviews[positions.center]} position="center" />
                <ReviewCard review={reviews[positions['right-1']]} position="right-1" />
                <ReviewCard review={reviews[positions['right-2']]} position="right-2" />
                {/* Navigation Buttons */}
                <button
                    className="absolute left-0 sm:left-2 top-1/2 -translate-y-1/2 bg-transparent text-custom-blue p-2 sm:p-3 rounded-full hover:bg-custom-yellow transition-colors"
                    onClick={prevSlide}
                >
                    <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
                    </svg>
                </button>
                <button
                    className="absolute right-0 sm:right-2 top-1/2 -translate-y-1/2 bg-transparent text-custom-blue p-2 sm:p-3 rounded-full hover:bg-custom-yellow transition-colors"
                    onClick={nextSlide}
                >
                    <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                    </svg>
                </button>
            </div>
            <div className="flex justify-center mt-6 sm:mt-8">
                {reviews.map((_, index) => (
                    <span
                        key={index}
                        className={`h-2 w-2 sm:h-3 sm:w-3 mx-1 rounded-full cursor-pointer ${index === currentSlide ? 'bg-custom-blue' : 'bg-gray-300'}`}
                        onClick={() => setCurrentSlide(index)}
                    ></span>
                ))}
            </div>
        </div>
    );
};

export default ReviewSlides;